import {CATEGORY_JS} from './Category';

import {AttributeJsNode} from '../../../nodes/js/Attribute';
import {GlobalsJsNode} from '../../../nodes/js/Globals';
import {OutputJsNode} from '../../../nodes/js/Output';
import {ParamJsNode} from '../../../nodes/js/Param';

export interface JsNodeChildrenMap {
	attribute: AttributeJsNode;
	globals: GlobalsJsNode;
	output: OutputJsNode;
	param: ParamJsNode;
}

import {PolyEngine} from '../../../Poly';
export class JsRegister {
	static run(poly: PolyEngine) {
		poly.registerNode(AttributeJsNode, CATEGORY_JS.GLOBALS);
		poly.registerNode(GlobalsJsNode, CATEGORY_JS.GLOBALS);
		poly.registerNode(OutputJsNode, CATEGORY_JS.GLOBALS);
		poly.registerNode(ParamJsNode, CATEGORY_JS.GLOBALS);
	}
}
